import React, { useEffect, useState } from "react";

import * as C from "components/collection/collectionElement";

import { MainRow, MainCol, Loader, MainContainer } from "components/common";

// Main Section card
import MainSectionCards from "components/collection/mainSectionCard";

// Collection Section
import CollectionSidebar from "components/collection/collectionSidebar";
import CollectionMobileSidebar from "components/collection/collectionMobileSidebar";

// sample Data
import { mainSectionData } from "components/data/mainSectionData";
import {
  AddFavouriteHook,
  GetSellNftsHook,
  RemoveFavouriteHook,
} from "hooks";
import {
  FilterRow,
  FilterTab,
  FilterTabPanel,
  SearchInput,
  ToggleButton,
  PriceSelect,
  PriceSelectOption,
  CardMainFlex,
} from "components/collectionAll/styles";

import { AiOutlineFilter } from "react-icons/all";
import { SearchOutlined } from "@ant-design/icons";
import { collectionAllCardData } from "components/data/collectionAll";
import CollectionCard from "components/collectionAll/collectionCard";
import { filterDataCollection } from "components/data/filterData";

import { MinMaxMain, AllNftWrapper } from "./styled";
import { useAppSelector } from "store/store";

const AllNftsCom = () => {
  const [filter, setFilter] = useState(true);

  //hooks
  const { sellNft, refetch } = GetSellNftsHook();
  const { addFav, data: addFavData } = AddFavouriteHook();
  const { removeFav, data: removeFavData } = RemoveFavouriteHook();

  //useAppSelector
  const { account } = useAppSelector((state) => state.web3Connect);

  //useEffect
  useEffect(() => {
    (addFavData || removeFavData) && refetch();
  }, [addFavData, removeFavData]);
  // Search Icon

  const suffix = (
    <SearchOutlined
      style={{
        fontSize: 16,
        color: "#1890ff",
      }}
    />
  );

  return (
    <AllNftWrapper style={{ overflowX: "hidden", marginTop: "2rem" }}>
      <MainContainer className="collectionContainer">
        <MainRow>
          <FilterRow>
            <div className="divTab ">
              <AiOutlineFilter
                className={filter ? "filterIcon " : "filterIcon active"}
                size={22}
                onClick={() => setFilter(!filter)}
              />

              <div>
                <FilterTab defaultActiveKey="1">
                  <FilterTabPanel tab="Items" key="1"></FilterTabPanel>
                  <FilterTabPanel
                    tab="Activity"
                    key="2"
                    disabled
                  ></FilterTabPanel>
                </FilterTab>
              </div>
            </div>
            <div className="searchMain">
              <div className="searchDiv">
                <SearchInput
                  prefix={
                    <SearchOutlined
                      style={{
                        fontSize: "16px",
                        paddingLeft: "1rem",
                        color: " #7F8C8D",
                      }}
                    />
                  }
                  placeholder="Search By Placeholder or attribute "
                />
              </div>
              <div className="selectDiv">
                <PriceSelect defaultValue="Price High To Low">
                  <PriceSelectOption value="Price High To Low">
                    Price High To Low
                  </PriceSelectOption>
                  <PriceSelectOption value="Price  Low To High ">
                    Price Low To High
                  </PriceSelectOption>
                </PriceSelect>
              </div>
            </div>
          </FilterRow>

          <MainCol lg={9} sm={7}></MainCol>
        </MainRow>

        <MainRow className="filterRow">
          <MainCol
            className={
              filter ? `col-lg-2 col-xs-12 sidebarCol ` : " d-none  hideScreen"
            }
          >
            <div className="filterDiv">
              <div className="flex justify-content-between filterFooter  ">
                <p className="buyTxt">Buy Now</p>
                <ToggleButton type="switch" id="mySwitch" />
              </div>
              <p className="priceRange mt-3">Price Range (ETH)</p>
              <MinMaxMain>
                <div className="minMaxMain mt-4">
                  <input type="text" placeholder="MIN" />
                  <input type="text" placeholder="MAX " />
                </div>
              </MinMaxMain>

              <input
                className="filterAllInput"
                type="text"
                placeholder="Filter properties "
              />
              <div className="mt-4">
                {filterDataCollection?.map((item) => (
                  <C.SidebarCollapse>
                    <C.SidebarCollapsePanel
                      header={item?.collapseHeaderTitle}
                      key="3"
                    >
                      <MainRow>
                        {item?.checkboxes.map((item2) => (
                          <>
                            <MainCol lg={12}>
                              <div>
                                <C.ChainSelect />{" "}
                                <span
                                  className="ms-3"
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {item2?.checkboxTitle}
                                </span>
                              </div>
                            </MainCol>
                            {item2?.checkboxCount && (
                              <MainCol lg={12}>
                                <C.BodyText>{item2?.checkboxCount}</C.BodyText>
                              </MainCol>
                            )}
                          </>
                        ))}
                      </MainRow>
                    </C.SidebarCollapsePanel>
                  </C.SidebarCollapse>
                ))}
              </div>
            </div>
          </MainCol>
          <MainCol
            className={filter ? "col-lg-10 col-xs-12 rightCol" : "col-lg-12"}
          >
            <CardMainFlex className="cardMainFlex  ">
              {sellNft?.data &&
                sellNft?.data?.map((item) => {
                  const fav = item.favourites.find(
                    (x) => x.user_address === account?.toLocaleLowerCase()
                  );
                  const data = {
                    changeFav: fav ? removeFav : addFav,
                    favId: fav?.id,
                    metadata_id: item?.meta_data.id,
                    metadata: {
                      id: item?.id,
                      price: item?.signed_order.erc20TokenAmount,
                      network: item.network,
                      erc20Token: item?.signed_order.erc20Token,
                      sold: item?.sold,
                      token_id: item?.meta_data?.token_id,
                      name:
                        item?.nft?.name || item?.meta_data?.asset_contract.name,
                    },
                    buttonTxt: item?.sold ? "Sold Out" : "Details",
                    image:
                      item?.nft?.image || item?.meta_data?.image_preview_url,
                    nft_id: item?.meta_data ? item.meta_data.id : item.nft_id,
                  };
                  return (
                    <div className={filter ? "cardItem" : "cardItem2"}>
                      <CollectionCard data={data} />
                    </div>
                  );
                })}
            </CardMainFlex>
          </MainCol>
        </MainRow>
      </MainContainer>
    </AllNftWrapper>
  );
};

export default AllNftsCom;
